<template>
  <div>
    <div id="captcha-element"></div>
  </div>
</template>

<script>
  import { setAesEncrypt } from '@/util/encrypt'
  import { encode } from 'js-base64'
  import { sendSmsCode } from '@/api/login'
  export default {
    data() {
      return {
        captcha: null
      }
    },
    props: {
      mobilePhone: {
        type: String,
        default: ''
      },
      verifyRefresh: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      verifyRefresh(newValue) {
        if (newValue) {
          this.captcha && this.captcha.refresh()
        }
      }
    },
    mounted() {
      window.initAliyunCaptcha({
        SceneId: '11y8z82l', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        prefix: 'jtdubp', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
        mode: 'embed', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
        element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
        onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
        getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
        slideStyle: {
          width: 396,
          height: 50
        }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
        immediate: true,
        autoRefresh: false
      })
    },
    beforeUnmount() {
      this.captcha = null
      // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
      document.getElementById('aliyunCaptcha-mask').remove()
      document.getElementById('aliyunCaptcha-window-popup').remove()
    },
    methods: {
      getInstance(instance) {
        this.captcha = instance
      },
      async captchaVerifyCallback(captchaVerifyParam) {
        try {
          const result = await sendSmsCode(
            setAesEncrypt(
              encode(JSON.stringify({ mobilePhone: this.mobilePhone, captchaVerifyParam }))
            )
          )
          if (result.code) {
            this.captcha.refresh()
            return
          }
          const data = result.data
          // captchaResult && bizResult为true表示校验通过，掉用emitResult返回校验结果
          if (data.captchaResult && data.bizResult) {
            this.$emit('emitResult', 1)
          } else {
            this.$emit('emitResult', 0)
          }
          return {
            captchaResult: data.captchaResult,
            bizResult: data.bizResult
          }
        } catch (err) {
          // 报错重置滑块
          this.captcha.refresh()
          return {
            captchaResult: false,
            bizResult: false
          }
        }
      },
      // 验证通过后调用
      onBizResultCallback() {
        console.log('onBizResultCallback')
      },
      // 弹出验证框，popupId为组件id，用于支持验证通过后继续触发业务逻辑
      popup(popupId) {
        this.popupId = popupId
      }
    }
  }
</script>

<style></style>
